import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { NgIf } from '../../../../node_modules/@angular/common';

import { AuthService } from '@services/auth/auth.service';
import { ContentService } from '@services/content/content.service';

import { HeaderComponent } from '../../core/components/header/header.component';
import { TaxYearsListComponent } from '../tax-years-list/tax-years-list.component';
import { FooterComponent } from '@components/footer/footer.component';
import { SessionExpiresComponent } from '@components/session-expires/session-expires.component';

@Component({
  selector: 'app-dashboard',
  imports: [HeaderComponent, TaxYearsListComponent, SessionExpiresComponent, NgIf, FooterComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent {
  firstName!: string;

  constructor(
    private authService: AuthService,
    private router: Router,
    public contentService: ContentService
  ) {}

  ngOnInit() {
    this.firstName = this.authService.getFirstName();
  }

  navigateToFormContainer(): void {
    this.router.navigate(['v2a/appl/10']);
  }
}
